import { components } from "@dzambalaorg/ui-kit";

import { MuiCardHeader, MuiCardMedia, MuiCardActionArea, MuiCard } from "./components";

export const customComponents = {
  ...components,
  MuiCard,
  MuiCardHeader,
  MuiCardMedia,
  MuiCardActionArea,
};
